
import React from 'react';
import { Helmet } from 'react-helmet';

export interface BreadcrumbItemType {
  name: string;
  url: string;
  position: number;
}

interface BreadcrumbStructuredDataProps {
  items: BreadcrumbItemType[];
  baseUrl: string;
}

export function BreadcrumbStructuredData({ items, baseUrl }: BreadcrumbStructuredDataProps) {
  // Create the structured data for breadcrumbs
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map(item => ({
      "@type": "ListItem",
      "position": item.position,
      "name": item.name,
      "item": item.url.startsWith('http') ? item.url : `${baseUrl}${item.url}`
    }))
  };
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
